module.exports = __webpack_public_path__ + "8d6d039b026e4b998135aca52f7d7a93.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/disp-column.jpg
// module id = 595
// module chunks = 0